import React, { useState } from "react";
import Button from "@mui/material/Button";
import Zoom from "@mui/material/Zoom";

function CreateComment(props) {
  const [isExpanded, setExpanded] = useState(false);
  const [comment, setComment] = useState({
    rating: "5",
    content: "",
  });
  const [error] = useState(null);

  function handleChange(event) {
    const { name, value } = event.target;

    setComment((prevComment) => {
      return {
        ...prevComment,
        [name]: value,
      };
    });
  }

  function submitComment(event) {
    if (props.userData === undefined || props.userData.banned === true) {
      return;
    }

    props.onAddComment(comment);
    event.preventDefault();
  }

  function expand() {
    setExpanded(true);
  }

  return (
    <div>
      <form className="create-comment">
        {isExpanded ? (
          <div className="comment-radio-stars d-flex justify-content-start">
            <p>Ocena: </p>
            <select name="rating" value={comment.rating} onChange={handleChange} id="">
              <option value="5">5 ⭐⭐⭐⭐⭐</option>
              <option value="4">4 ⭐⭐⭐⭐</option>
              <option value="3">3 ⭐⭐⭐</option>
              <option value="2">2 ⭐⭐</option>
              <option value="1">1 ⭐</option>
            </select>
          </div>
        ) : null}
        <textarea
          name="content"
          onClick={expand}
          onChange={handleChange}
          value={comment.content}
          placeholder={isExpanded ? "Pozostawiając puste zostanie dodana jedynie ocena" : "dodaj ocenę/komentarz"}
          rows={isExpanded ? 3 : 1}
        />
        <Zoom in={isExpanded}>
          <div className="d-flex justify-content-start">
            <Button variant="contained" onClick={submitComment}>
              Dodaj
            </Button>
            <p className="create-comment-error">{error}</p>
          </div>
        </Zoom>
      </form>
    </div>
  );
}

export default CreateComment;
